export const PERMS = {
    READ: 'goods_types.read',
    UPDATE: 'goods_types.update',
    DELETE: 'goods_types.delete',
    CREATE: 'goods_types.create',
    EXPORT: 'goods_types.export',
}
